<template>
  <div>
    <!--
    <div id="v-step-0">A DOM element on your page. The first step will pop on this element because its ID is 'v-step-0'.</div>
    <div id="v-step-1">A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'.</div>
    <div id="v-step-2">A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'.</div>
-->
    <v-tour name="HomeTour" :steps="steps" :callbacks="myCallbacks">
      <template v-slot="{ tour }">
        
          <v-step
            v-if="tour && tour.steps && tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            style="z-index: 2000;"
          >
            <template v-if="tour.currentStep === 9">
              <div>
                <button
                  @click="tour.skip"
                  class="v-step__button v-step__button-previous"
                >
                  Skip tour
                </button>
                <button
                  @click="tour.previousStep"
                  class="v-step__button v-step__button-previous"
                >
                  Previous step
                </button>
                <button
                  @click="tour.stop"
                  class="v-step__button v-step__button-skip"
                >
                  Got it!
                </button>
              </div>
            </template>
          </v-step>
       
      </template>
    </v-tour>
  </div>
</template>

<script>
export default {
  name: "home-tour",
  data() {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Discover Spacenet 3!",
          },
          content: `<p style="font-weight: 300;">The Collaborate section is for asking questions, and sharing items with the Spacesaver Group. Future releases will include photo uploads and sharing of Cool Installs!</p>`,
          params: {
            placement: "left-end", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-1",
          header: {
            title: "The Document Library",
          },
          content: `
            <p style="font-weight: 300;">Marketing Materials contains marketing collateral, photos, videos and PDFs.
            Service & Installation contains documentation and install manuals, while
            Sales & Training Support houses general documents related to customer support, contracts etc.</p>
            `,
          params: {
            placement: "left-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-2",
          header: {
            title: "Order Management",
          },
          content:
            '<p style="font-weight: 300;">You\'ll love the improvements we made to the order management section!</p>',
          params: {
            placement: "left-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-3",
          header: {
            title: "Tools",
          },
          content:
            '<p style="font-weight: 300;">This section contains useful tools like an interactive map of area contractor regions, as well as price lists and an FAQ.</p>',
          params: {
            placement: "left-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-4",
          header: {
            title: "News menu",
          },
          content:
            '<p style="font-weight: 300;">The help tour can be enabled and disabled in this section. Alerts for expedited orders and collaborate posts also appear here.</p>',
          params: {
            placement: "left-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-5",
          header: {
            title: "User menu",
          },
          content:
            '<p style="font-weight: 300;">The help tour can be enabled and disabled in this section. Alerts for expedited orders and collaborate posts also appear here.</p>',
          params: {
            placement: "left-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
      myCallbacks: {
        onSkip: this.customSkipStepCallback,
      },
    };
  },
  methods: {
    customSkipStepCallback: function () {
      // console.log("Hello");
      this.$store.commit("hideTour");
      this.$toast.success("The help tour has been disabled.", { hideProgressBar: false, icon: false });
    },
  },
  mounted: function () {
    this.$tours["HomeTour"].start();
  },
};
</script>
<style>
.v-step {
  /*background: #F16231!important;*/
  background: #50596c;
  background: #5f6d7b !important;
  color: #fff;
  max-width: 320px;
  border-radius: 3px;
  -webkit-filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  padding: 1rem;
  text-align: center;
  z-index: 2000;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.28);
}
.v-step__header {
  margin: -1rem -1rem 0.5rem;
  padding: 0.5rem;
  background-color: #454d5d;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>
